import {
  APPLICATION_CLARIFICATION_STATUS,
} from '../../../../../config/constants'

import './client-clarifications-section.scss'
import {
  useTranslation,
} from 'react-i18next'
import {
  Box,
  Typography,
} from '@mui/material'
import {
  COLORS,
} from 'config/constants'

import {
  orphanClarifications,
} from '../check-block-utils'
import CheckItemClarificationReply from './check-item-clarification-reply'


const ClientClarificationsSection = ({ app, managerView, runAction, onAnswer }: ApplicationClientClarificationsProps) => {
  const { t } = useTranslation()
  const orphanClarificationList = orphanClarifications(app)
  return (<div className='application-client-clarifications-section'>
    {!managerView && orphanClarificationList.length > 0 && (
      <Box className='application-client-clarifications-section__section'>
        <Typography
          component='h2'
          variant='subtitle1'
          className='application-client-clarifications-section__section-title'
          sx={{ color: COLORS.BLACK_DARK, fontWeight: 600 }}
        >
          {t('applications__text__clarifications')}
        </Typography>
        {orphanClarificationList.map((c) => (
          <div key={c.id} className='application-client-clarifications-section__clarification'>
            {c.status === APPLICATION_CLARIFICATION_STATUS.OPEN ? (
              <CheckItemClarificationReply
                clarification={c}
                runAction={runAction}
                onAnswer={onAnswer}
              />
            ) : (
              <>
                <Typography variant='body2' sx={{ fontWeight: 600 }}>
                  {c.title || t('applications__text__clarification')}
                </Typography>
                <Typography variant='body2'>{c.question}</Typography>
                {c.answer_text && (
                  <Typography variant='body2' sx={{ color: COLORS.LIGHT_TEXT_SECONDARY }}>
                    {t('applications__text__yourAnswer')}: {c.answer_text}
                  </Typography>
                )}
              </>
            )}
          </div>
        ))}
      </Box>
    )}

  </div>)
}
export default ClientClarificationsSection
